module.exports = __webpack_public_path__ + "files/a88ef1a6322a996748c29a01374444bc.svg";